import { ga, avocet } from 'js/analytics/adapters'
export const trackRegistrationMethod = ({ method }) => {
  const props = { 'Registration Method': method }
  ga.track('Choose Registration Method', props)
  avocet.track('Choose Registration Method', { method })
}
